export default "__VITE_ASSET__BottktqB__"